import { SvgProps } from 'models/svg';

const LockSvg = ({ className }: SvgProps) => {
  return (
    <svg width='8' height='12' viewBox='0 0 8 12' fill='none' xmlns='http://www.w3.org/2000/svg' className={className}>
      <path
        d='M2.5 3.125V4.375H5V3.125C5 2.44141 4.43359 1.875 3.75 1.875C3.06641 1.875 2.5 2.44141 2.5 3.125ZM1.25 4.375V3.125C1.25 1.73828 2.36328 0.625 3.75 0.625C5.13672 0.625 6.25 1.73828 6.25 3.125V4.375C6.93359 4.375 7.5 4.94141 7.5 5.625V10C7.5 10.6836 6.93359 11.25 6.25 11.25H1.25C0.566406 11.25 0 10.6836 0 10V5.625C0 4.94141 0.566406 4.375 1.25 4.375Z'
        fill='#6C727F'
      />
    </svg>
  );
};

export default LockSvg;
